var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "company-specific-info-card", style: { height: "60%" } },
    [
      _c(
        "div",
        { staticClass: "tabs-and-button-container" },
        [
          _c("tabs", {
            attrs: {
              tabs: _vm.tabs,
              "active-tab": _vm.activeTab,
              "tabs-styling": _vm.tabsStyling,
              "tabs-labels-styling": _vm.tabsLabelsStyling,
              "center-tabs": false
            },
            on: {
              startTabChange: function($event) {
                _vm.activeTab = $event
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.tabs[_vm.activeTab].id === "fields"
        ? _c(
            "div",
            { style: { height: "calc(100% - 102px)", "margin-top": "21px" } },
            [
              _c("Table", {
                attrs: {
                  checkbox: false,
                  removeTableLines: false,
                  loading: _vm.loading,
                  headers: _vm.fieldsHeaders,
                  items: _vm.fields,
                  "add-row-button": _vm.editingData,
                  "action-buttons": _vm.editingData
                },
                on: {
                  input: function($event) {
                    return _vm.updateFieldValue($event)
                  },
                  save: function($event) {
                    return _vm.saveFields($event)
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.editingData
        ? _c(
            "div",
            { staticClass: "action-buttons" },
            [
              _c("custom-button", {
                attrs: {
                  label: _vm.$t("Cancel"),
                  "button-color": "#FFF",
                  "label-color": "var(--app-primary-base)",
                  "button-styling": _vm.actionButtonsStyling
                },
                on: {
                  buttonClick: function($event) {
                    return _vm.$emit("cancel-edit")
                  }
                }
              }),
              _vm._v(" "),
              _c("custom-button", {
                attrs: {
                  label: _vm.$t(_vm.submitButtonLabel),
                  "button-color": "var(--app-primary-base)",
                  "label-color": "#FFF",
                  "button-styling": _vm.actionButtonsStylingSave,
                  disabled: !_vm.requiredFieldsFilled
                },
                on: {
                  buttonClick: function($event) {
                    return _vm.$emit("save-template")
                  }
                }
              })
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-237598e4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-237598e4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/newComponents/WorkspaceManagement/Templates/ImportSpecificInfo.vue
// module id = null
// module chunks = 